import React                      from 'react'
import { Observer }               from 'mobx-react'
import { Button
       , Layout }                 from 'antd'

import { kde_api_user_t }         from '../02_api'
import { create_user_modal
       , Toolbar
       , UsersTable }             from '../10_ui'


import { TEXT
       , tr }                     from '../00_assets'
import { MUsers }                 from './01_screen_users_model'


export const UsersScreen: React.FC = () =>
<Observer render={ ( ) =>
{
  const model   = MUsers.instance( )
      , src     = model.users.data_for_page( 0 )
      , on_delete_user = (user: kde_api_user_t) => ( ) =>
        {
          if ( window.confirm( tr( TEXT.ARE_YOU_SURE ) ) )
               model.users.on_delete( user ) ;
        }
        , on_edit_user = ( user: kde_api_user_t, new_values: Partial<kde_api_user_t> ) =>
        {
          model.users.on_edit( user, new_values );
        }
      , on_create_element = ( ) =>
        {
          create_user_modal( model.users.on_add ) ;
        } ;
          // model.rename_workgroup( user, window.prompt( tr( TEXT.USERS_NEW_NAME ) ) )


  return <Layout.Content className="scrollable">
          <Toolbar>
            <Button
                className="ml-auto"
                onClick={ on_create_element }
                type="primary"
            >
              {  tr( TEXT.USERS_NEW_TITLE ) }
            </Button>
         </Toolbar>
         <UsersTable
              loading={ src.loading }
              users={ src.data.slice( 0 ) }
              onDelete={ on_delete_user }
              onEdit={ on_edit_user }
              canEdit={ true }
            />
        </Layout.Content>
} }/>
